import { css } from '@emotion/react';
import React from 'react';

function ColorCircle({ color }) {
	return (
		<div
			css={css`
				width: 15px;
				height: 15px;
				margin-right: 0.5rem;
				border-radius: 100px;
				background: ${color};
			`}
		></div>
	);
}

export default ColorCircle;
